import { all, call, put, SagaReturnType, select, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as addImageActions from '@/components/modals/addImage/Actions';
import { addImageModalActionTypes } from '@/components/modals/addImage/Constants';
import { processRequest } from '@/services/Api';

import { getUploadType } from '@/components/modals/addImage/Selectors';

import type { GetImagesRequestAction, UploadImageRequestAction } from './types';

export default function* addImageModalSagas(): Generator {
	yield all([
		takeLatest(addImageModalActionTypes.GET_IMAGES_REQUEST, handleImagesRequest),
		takeLatest(addImageModalActionTypes.UPLOAD_IMAGE_REQUEST, handleUploadImageRequest),
	]);
}

export function* handleImagesRequest(action: GetImagesRequestAction) {
	try {
		const { query } = action.payload;
		const response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			`external_services/pixabay_images?term=${query}`,
		);

		const data = response.data as { image_urls: string[] };
		yield put(addImageActions.getImagesSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(addImageActions.getImagesError());
	}
}

export function* handleUploadImageRequest(action: UploadImageRequestAction) {
	try {
		const { file, itemId } = action.payload;
		const type: SagaReturnType<typeof getUploadType> = yield select(getUploadType);

		const response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			`${type}/presigned_image_url`,
		);
		const presignedUrl = (response.data as { signed_url: string }).signed_url;

		yield call(processRequest, presignedUrl, 'PUT', file, true);

		const linkToFile = presignedUrl.split('?')[0];

		yield put(addImageActions.uploadImageSuccess(linkToFile, itemId));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(addImageActions.uploadImageError());
	}
}
